module.exports = __webpack_public_path__ + "static/media/9.ed5b9cea.svg";